import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import AuthorizService from '@/services/AuthorizService';
import jwt_decode from 'jwt-decode';
import router from './router';

Vue.use(Vuex);

// Inlined at build time from `.env.production`. Empty is the meaningful default
// for the portal's own api -- these are concatenated, not joined, so '' leaves a
// relative url that resolves against the origin serving the app, and a missing
// var can never produce "undefinedapi/token/". The Auction API is deliberately
// not defaulted: it lives on another host, and a wrong guess there fails
// quietly, whereas an unset one is visible in the network log.
const apiUrl = process.env.VUE_APP_API_URL || '';
const apiAtreus = process.env.VUE_APP_API_ATREUS_URL;
const auctionURL = process.env.VUE_APP_AUCTION_URL;

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    jwt: localStorage.getItem('t'),
    apiUrl,
    endpoints: {
      obtainJWT: apiUrl + 'api/token/',
      refreshJWT: apiUrl + 'api/token/refresh/',
    },
    anonymousParticipationUrl: '',
    auctionURL,
    apiAtreus,
    backGroundColor: '#dcdcdc',
    backgroundColorForWidget: '#dcdcdc',
    colorHeader: '#ffffff',
    backgroundImage: 'none',
    headerTitleColor: 'green',
    backgroundForTiming: 'grey',
    zoomBlock: '420px',
    buttonColor: '#B3672B',
    loginInfo: {
      isLogged: false,
      accessToken: '',
      refreshToken: '',
    },
    userInfo: {
      auctions: [],
      bids: [],
    },
    profileInfo: {
      username: '',
      userImage: '',
      companyImage: '',
    },
    simpleData: {
      apiEndpoint: '',
      docs: '',
      userGuide: '',
    },
    showLoading: false,
    isShowSnackbar: false,
    snackbarText: '',
    showLoadingText: '',
    isAnonymousBidderCreatedBid: false,
  },
  mutations: {
    setProfileUsername(state, username) {
      state.profileInfo.username = username;
    },
    setBackGroundColor(state, color) {
      state.backGroundColor = color;
    },
    setColorHeader(state, color) {
      state.colorHeader = color;
    },
    setBackgroundImage(state, imageUrl) {
      state.backgroundImage = imageUrl;
    },
    setSimpleData(state, data) {
      state.simpleData.apiEndpoint = data.apiEndpoint || '';
      state.simpleData.docs = data.docs || '';
      state.simpleData.userGuide = data.userGuide || '';
    },
    setWidgetBackgroundColor(state, color) {
      state.backgroundColorForWidget = color;
    },
    setWidgetTimingBackground(state, color) {
      state.backgroundForTiming = color;
    },
    setWidgetHeaderTitleColor(state, color) {
      state.headerTitleColor = color;
    },
    setWidgetButtonColor(state, color) {
      state.buttonColor = color;
    },
    setWidgetZoomBlock(state, value) {
      state.zoomBlock = value;
    },
    setLoadingState(state, payload) {
      state.showLoading = Boolean(payload && payload.show);
      state.showLoadingText = payload && payload.text ? payload.text : '';
    },
    setSnackbarState(state, payload) {
      state.isShowSnackbar = Boolean(payload && payload.show);
      state.snackbarText = payload && payload.text ? payload.text : '';
    },
    bidderCreatedBid(state, data) {
      state.isAnonymousBidderCreatedBid = data;
    },
    setAnonymousParticipationUrl(state, url) {
      state.anonymousParticipationUrl = url;
    },
    setUserInfo(state, data) {
      state.userInfo.auctions = data.auctions;
      state.userInfo.bids = data.bids;
    },
    setUserProfileInfo() {
      // state.profileInfo.username = data.username
      // state.profileInfo.userImage = data.extendedUser.image
      // state.profileInfo.companyImage = data.extendedUser.company.image
    },
    login(state, data) {
      state.loginInfo.isLogged = true;
      state.loginInfo.accessToken = data.access;
      state.loginInfo.refreshToken = data.refresh;
    },
    logout(state) {
      state.loginInfo.isLogged = false;
      state.loginInfo.accessToken = '';
      state.loginInfo.refreshToken = '';
      router.push({ name: 'login' });
    },
  },
  actions: {
    setLoading({ commit }, payload) {
      commit('setLoadingState', payload);
    },
    showSnackbar({ commit }, text) {
      commit('setSnackbarState', { show: true, text });
    },
    inspectToken({ commit, state }, context) {
      return new Promise((resolve, reject) => {
        context = context || {};
        if (context.isAnonymous) {
          resolve();
        }
        if (this.state.loginInfo.accessToken) {
          const decoded_refresh = jwt_decode(this.state.loginInfo.refreshToken);
          const decoded_access = jwt_decode(this.state.loginInfo.accessToken);
          if (
            decoded_access.exp - Date.now() / 1000 < 0 &&
            decoded_refresh.exp - Date.now() / 1000 > 0
          ) {
            axios
              .post(state.endpoints.refreshJWT, { refresh: this.state.loginInfo.refreshToken })
              .then((response) => {
                this.state.loginInfo.accessToken = response.data.access;
                this.state.showLoading = false;
                resolve();
                // router.push({name: 'auctionList'})
              })
              .catch(() => {
                commit('logout');
                reject();
              });
          } else if (decoded_refresh.exp - Date.now() / 1000 < 0) {
            commit('logout');
            resolve();
          } else {
            resolve();
          }
        }
      });
    },
    getUserInfo(context) {
      AuthorizService.authorizMyItems(context.state.apiUrl, context.state.loginInfo.accessToken)
        .then((response) => {
          context.commit('setUserInfo', response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUserProfileInfo(context) {
      AuthorizService.authorizProfile(context.state.apiUrl, context.state.loginInfo.accessToken)
        .then((response) => {
          context.commit('setUserProfileInfo', response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
});
